import { CHANGE_SYSTEM_RESOURCES } from "../actions/types";
import { avatarIds } from "./../images/avatars";

const INITIAL_STATE = {
  avatarIds: avatarIds, // avatar ids available
  languages: ["zh-CN", "en-US"],
  background: ["background1", "background2", "background3", "background4", "background5", "background6"],
  // TO DO: will update more of these info
}

const systemResourcesReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case CHANGE_SYSTEM_RESOURCES:
      return { 
        ...state,
        // DO TO
      };

    default: 
      return state;
  }
}

export default systemResourcesReducer;